import parse, { HTMLReactParserOptions, Element, domToReact, DOMNode } from 'html-react-parser'

interface ParsedContentProps {
  content: string
  className?: string
}

const parserOptions: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (domNode instanceof Element) {
      // Replace p tags that contain iframes with a div
      if (domNode.name === 'p' && domNode.children.some(child => child instanceof Element && child.name === 'iframe')) {
        return (
          <div className="w-full flex justify-center my-6">
            <div className="w-[560px] max-w-full">
              <div className="relative w-full aspect-video">
                {domToReact(domNode.children as DOMNode[], parserOptions)}
              </div>
            </div>
          </div>
        )
      }

      // Replace iframe to make it responsive
      if (domNode.name === 'iframe') {
        const { width, height, ...restAttribs } = domNode.attribs
        return (
          <div className="video-responsive-container">
            <iframe
              {...restAttribs}
              className="video-responsive-iframe"
              allowFullScreen
            />
          </div>
        )
      }

      // Replace p tags with spans to avoid hydration issues
      if (domNode.name === 'p') {
        const style = domNode.attribs?.style || ''
        const isTextCenter = style.includes('text-align: center')
        return (
          <span className={`block mb-4 w-full ${isTextCenter ? 'text-center' : ''}`}>
            {domToReact(domNode.children as DOMNode[], parserOptions)}
          </span>
        )
      }
    }
  }
}

export function ParsedContent({ content, className = '' }: ParsedContentProps) {
  return (
    <div className={`content-html ${className}`}>
      {parse(content, parserOptions)}
    </div>
  )
} 